"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useLexicalNodeSelection } from '@lexical/react/useLexicalNodeSelection';
import { useComboBox } from '../../../ComboBox/context/use-combobox.mjs';
import { useNestedComboBox } from '../../../ComboBox/context/use-nested-combobox.mjs';
import { $isEditorTagNode } from './EditorTagNode.mjs';
import { useIsFieldFrozen } from '../../../DataBuilder/hooks.mjs';
import useDataBuilder from '../../../DataBuilder/use-data-builder.mjs';
import { $getNodeByKey } from 'lexical';

const EditorTagBinding = ({
  internalKey,
  value,
  autoOpen
}) => {
  const { isReadOnly } = useDataBuilder();
  const isFrozenField = useIsFieldFrozen();
  const { variablesSchema, schema } = useComboBox();
  const ComboBox = useNestedComboBox();
  const [editor] = useLexicalComposerContext();
  const [isSelected] = useLexicalNodeSelection(internalKey);
  const handleChange = (value2) => {
    editor.update(() => {
      const node = $getNodeByKey(internalKey);
      if ($isEditorTagNode(node)) {
        if (value2 === void 0) {
          node.remove();
        } else {
          node.setValue(value2);
        }
      }
    });
  };
  return /* @__PURE__ */ jsx(
    ComboBox,
    {
      value,
      schema,
      variablesOnly: true,
      disabled: isReadOnly || isFrozenField,
      variablesSchema,
      onChange: handleChange,
      autoOpen,
      "data-selected": isSelected
    }
  );
};

export { EditorTagBinding };
